import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon, MailIcon, ShoppingCartIcon, CameraIcon } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
export function RecommendationsPage() {
  const {
    t
  } = useLanguage();
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  function renderButton(rec: {
    contact: string;
    buttonLabel?: string;
  }) {
    // Email contact
    if (rec.contact.includes('@')) {
      return <a href={`mailto:${rec.contact}`} className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-medium bg-teal-50 hover:bg-teal-100 px-4 py-2 rounded-lg transition-colors" data-id="element-326">
          <MailIcon size={18} data-id="element-327" />
          <span data-id="element-328">Contact</span>
        </a>;
    }
    // Portfolio button
    if (rec.contact === 'portfolio') {
      return <span className="inline-flex items-center space-x-2 text-teal-600 font-medium bg-teal-50 px-4 py-2 rounded-lg" data-id="element-329">
          <CameraIcon size={18} data-id="element-330" />
          <span data-id="element-331">{rec.buttonLabel || 'Portfolio'}</span>
        </span>;
    }
    // Website link (default)
    const url = rec.contact.startsWith('http') ? rec.contact : `https://${rec.contact}`;
    const icon = rec.buttonLabel === 'Shop Products' || rec.buttonLabel === 'Acheter' ? <ShoppingCartIcon size={18} data-id="element-332" /> : <ExternalLinkIcon size={18} data-id="element-333" />;
    return <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-medium bg-teal-50 hover:bg-teal-100 px-4 py-2 rounded-lg transition-colors" data-id="element-334">
        {icon}
        <span data-id="element-335">{rec.buttonLabel || 'Website'}</span>
      </a>;
  }
  return <div className="pt-24 pb-20 bg-white min-h-screen" data-id="element-336">
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 overflow-hidden bg-teal-50/50" data-id="element-337">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-338">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-teal-100/40 blur-3xl" data-id="element-339" />
          <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-teal-50/60 blur-3xl" data-id="element-340" />
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-341">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-342">
            <h1 className="text-4xl md:text-5xl font-serif font-medium text-teal-900 mb-6" data-id="element-343">
              {t.recommendations.title}
            </h1>
            <p className="text-xl text-slate-600 mb-4" data-id="element-344">
              {t.recommendations.subtitle}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Recommendations List */}
      <section className="py-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-345">
        <div className="space-y-6" data-id="element-346">
          {t.recommendations.list.map((rec, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 md:p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-347">
              <div className="flex-1" data-id="element-348">
                <h3 className="text-xl font-medium text-teal-900 mb-1" data-id="element-349">
                  {rec.name}
                </h3>
                <p className="text-sm font-medium text-teal-600 mb-3 uppercase tracking-wider" data-id="element-350">
                  {rec.specialty}
                </p>
                <p className="text-slate-600 leading-relaxed" data-id="element-351">
                  {rec.description}
                </p>
              </div>
              <div className="shrink-0" data-id="element-352">{renderButton(rec)}</div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}